module.exports = __webpack_public_path__ + "static/Erfolgreiches-daed2aa9f19ace70556e4361d84afdff.gif";